import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { MemoryMonitorController } from "./components/observability/MemoryMonitorController";
import { PostHogAnalyticsProvider } from "./components/observability/PostHogAnalyticsProvider";
import "./index.css";
import "./services/otel";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PostHogAnalyticsProvider>
    <MemoryMonitorController />
    <App />
  </PostHogAnalyticsProvider>
);
